import type { ComponentType, ReactNode } from 'react';

export type TabKey = number | string;

export type TabItemProps = {
  /**
   * Подпись вкладки
   */
  label: string;
  /**
   * Содержимое ярлыка
   */
  badge?: ReactNode,
  /**
   * Ссылка
   *
   * Удобно использовать в связке с withRouter (см. свойство у Tabs)
   *
   * Если он указан, то используется в качестве tabKey
   */
  url?: string;
  activeUrl?: string[];
  tabKey?: TabKey,
  children?: ReactNode,
  onClick?: (tabKey: TabKey) => void;
};

/**
 * Компонент обертка с информацией о вкладе и ее содержимым
 * Необходим для извлечения информации из props
 * Возвращает просто свое содержимое
 */
export const TabItem: ComponentType<TabItemProps> = ({
  children,
}: TabItemProps) => (children != null ? children : null);
